import styled from "styled-components";
import { breakpointRuleDesktop, breakpointRuleTablet, maxContentWidth } from "./variables";
import { motion } from "framer-motion";
const sectionPaddingMobile = '15px';
const sectionPaddingTablet = '48px';
export const SectionContainerWrapper = styled(motion.div) `
    margin: 0 auto;
    max-width: ${maxContentWidth};
`;
export const SectionContainer = styled(motion.div) `
    display: flex;
    flex-direction: column;

    padding: 0 ${sectionPaddingMobile};

    & > ${SectionContainerWrapper} {
        flex-grow: 1;
        width: 100%;
    }

    @media (${breakpointRuleTablet}) {
        padding: 0 ${sectionPaddingTablet};
    }

    @media (${breakpointRuleDesktop}) {
        padding: 0 ${sectionPaddingMobile};
    }
`;
